import { api } from "@/builders/axios";

// Unable to type the response because there is no response body in the schema

const get = function () {
  return api.get("");
};

export const brochure = {
  get,
};
